import { render, staticRenderFns } from "./InstallationTreePath.vue?vue&type=template&id=0f8c6d20&"
import script from "./InstallationTreePath.vue?vue&type=script&lang=ts&"
export * from "./InstallationTreePath.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardSubtitle})
